module.exports = __webpack_public_path__ + "img/menu-05.d71e2768.svg";